import { stripHTML } from 'lib/utils/helpers/strip-html';
import { DateTime } from 'luxon';
import { User } from '../users/users';
import { SymptomType } from './choices/symptom-type';

export interface SymptomLikeVersionConstructorOpts {
  id?: number;
  version?: number;
  symptomId?: number;

  isActive?: boolean;
  isHidden?: boolean;

  author?: User;
  comment?: string;
  created?: DateTime;

  name: string;
  synonyms: string[];
  type: SymptomType;
  description: string;
}

export class SymptomLikeVersion {
  public readonly id: number | undefined;
  public readonly version: number | undefined;
  public readonly symptomId: number | undefined;

  public readonly isActive: boolean | undefined;
  public readonly isHidden: boolean | undefined;

  public readonly author: User | undefined;
  public readonly created: DateTime | undefined;
  public comment: string | undefined;

  public name: string;
  public synonyms: string[];
  public type: SymptomType;
  public description: string;

  constructor(opts: SymptomLikeVersionConstructorOpts) {
    this.id = opts.id;
    this.version = opts.version;
    this.symptomId = opts.symptomId;

    this.isActive = opts.isActive;
    this.isHidden = opts.isHidden;

    this.author = opts.author;
    this.comment = opts.comment;
    this.created = opts.created;

    this.name = opts.name;
    this.synonyms = opts.synonyms;
    this.type = opts.type;
    this.description = opts.description || '';
  }

  toString() {
    return (
      '<SymptomLikeVersion: ' +
      this.id +
      ', version=' +
      this.version +
      ', symptomId=' +
      this.symptomId +
      '>'
    );
  }

  descriptionText(): string {
    return stripHTML(this.description);
  }

  toJson(): any {
    return {
      id: this.id,
      version: this.version,
      symptom: this.symptomId,
      is_active: this.isActive,
      is_hidden: this.isHidden,
      author: this.author?.toJson(),
      comment: this.comment,
      created: this.created?.toISO(),
      name: this.name,
      synonyms: this.synonyms,
      description: this.description,
      kind: this.type.key
    };
  }

  static fromJson(json: any): SymptomLikeVersion {
    const opts: SymptomLikeVersionConstructorOpts = {
      id: json.id,
      version: json.version || undefined,
      symptomId: json.symptom || undefined,

      isActive: json.is_active || undefined,
      isHidden: json.is_hidden || undefined,

      author: json.author ? User.fromJson(json.author) : undefined,
      comment: json.comment || '',
      created: json.date_created ? DateTime.fromISO(json.date_created) : undefined,

      name: json.name,
      synonyms: json.synonyms || [],
      description: json.description || '',
      type: SymptomType.fromKey(json.kind)
    };

    return new SymptomLikeVersion(opts);
  }
}
